module.exports = __webpack_public_path__ + "img/logo_happily_stacked@2x.5a8f6443.png";